export const UNMAPPED_COLORS = {
  lightRedGradient: '#F8E8E8',
  lightBlueGrayGradient: '#eceef8',
  lightBlueGradient: '#E8F6FC',
  lightGrayGradient: '#F2F2F2',
  lightBlueGradient2: '#F0FBFF',
  lightGrayShade: '#F8FAFC',
  lightGrayShade2: '#F9FAFB',
  darkGrayShade: '#686868',
  lightYellowShade: '#FFF9E6',
  lightGreenShade: '#EDF7EE',
  darkGreenShade: '#2A602C',
  darkYellowShade: '#8B6B00',
  darkRedShade: '#650F0F',
  lightYellowShade2: '#FEECB0',
  lightGreenShade2: '#C8E6C9',
  timePickerArrowDisabledBgColor: '#cccccc',
  timePickerArrowDisabledColor: '#666666',
  timePickerArrowHoverBgColor: '#03A9F40F',
  darkBlueShade: '#02557A',
  darkOrangeShade: '#874400',
  lightOrangeShade: '#FCD6B0',
}
